var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyElephant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 406,
    viewBox: "0 0 554 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.811 54.1281C184.811 54.1281 136.254 -14.2932 63.4176 10.7214C-9.41708 35.7361 -23.3971 180.671 43.5536 238.057C110.504 295.443 198.054 223.343 198.054 223.343L184.811 54.1281Z",
    fill: "#829AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.297 85.8976C187.297 85.8976 134.396 21.851 76.2931 41.8056C18.1905 61.759 5.7798 170.944 59.1878 216.722C112.594 262.499 196.106 198.463 196.106 198.463L187.297 85.8976Z",
    fill: "#486581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.148 54.1281C369.148 54.1281 417.706 -14.2932 490.54 10.7214C563.378 35.7361 577.355 180.671 510.406 238.057C443.455 295.443 355.904 223.343 355.904 223.343L369.148 54.1281Z",
    fill: "#829AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.662 85.8976C366.662 85.8976 419.563 21.851 477.666 41.8056C535.769 61.759 548.178 170.944 494.771 216.722C441.365 262.499 357.853 198.463 357.853 198.463L366.662 85.8976Z",
    fill: "#486581"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.62 50.1977C177.62 50.1977 105.283 141.428 99.1777 260.236C99.1777 260.236 143.962 262.535 168.99 237.779C193.398 213.636 177.62 50.1977 177.62 50.1977Z",
    fill: "#002159"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402.255 158.6C410 11.4361 309.135 -0.0412255 277.111 9.5207e-05C277.067 9.5207e-05 277.024 9.5207e-05 276.979 9.5207e-05C276.935 9.5207e-05 276.892 9.5207e-05 276.848 9.5207e-05C244.824 -0.0412255 143.959 11.4361 151.704 158.6C151.704 158.6 104.032 195.335 128.162 240.264C155.528 291.224 247.44 298.605 273.502 299.675L273.504 299.857C273.504 299.857 274.747 299.856 276.979 299.795C279.212 299.856 280.454 299.857 280.454 299.857L280.458 299.675C306.519 298.605 398.431 291.224 425.798 240.264C449.927 195.335 402.255 158.6 402.255 158.6Z",
    fill: "#829AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.255 158.6C407.604 56.9588 361.146 20.0481 321.339 6.94946C345.276 25.9228 399.644 52.7961 390.47 161.72C390.47 161.72 443.307 199.863 411.73 258.385C417.356 253.057 422.154 247.051 425.798 240.264C449.927 195.335 402.255 158.6 402.255 158.6Z",
    fill: "#BCCCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.586 156.944C228.586 163.954 223.562 169.636 217.366 169.636C211.17 169.636 206.146 163.954 206.146 156.944C206.146 149.935 211.17 144.254 217.366 144.254C223.562 144.254 228.586 149.935 228.586 156.944Z",
    fill: "#084082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.552 147.051C212.111 147.051 210.739 147.369 209.474 147.928C207.42 150.228 206.147 153.417 206.147 156.944C206.147 163.953 211.17 169.636 217.366 169.636C218.807 169.636 220.179 169.317 221.444 168.759C223.498 166.459 224.772 163.269 224.772 159.741C224.772 152.732 219.748 147.051 213.552 147.051Z",
    fill: "#334E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.08 156.944C347.08 163.954 342.056 169.636 335.86 169.636C329.664 169.636 324.64 163.954 324.64 156.944C324.64 149.935 329.664 144.254 335.86 144.254C342.056 144.254 347.08 149.935 347.08 156.944Z",
    fill: "#084082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.046 147.051C330.605 147.051 329.233 147.369 327.967 147.928C325.914 150.228 324.641 153.417 324.641 156.944C324.641 163.953 329.663 169.636 335.861 169.636C337.301 169.636 338.673 169.317 339.938 168.759C341.991 166.459 343.266 163.269 343.266 159.741C343.266 152.732 338.242 147.051 332.046 147.051Z",
    fill: "#334E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.174 159.877C344.174 162.229 342.267 164.136 339.915 164.136C337.563 164.136 335.655 162.229 335.655 159.877C335.655 157.525 337.563 155.619 339.915 155.619C342.267 155.619 344.174 157.525 344.174 159.877Z",
    fill: "#084082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.832 159.877C225.832 162.229 223.925 164.136 221.573 164.136C219.221 164.136 217.313 162.229 217.313 159.877C217.313 157.525 219.221 155.619 221.573 155.619C223.925 155.619 225.832 157.525 225.832 159.877Z",
    fill: "#084082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.597 339.729C366.597 339.729 366.804 341.114 367.165 343.684",
    stroke: "#FFE3E3",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.199997,
    d: "M238.012 187C238.012 187 203.661 218.465 190.069 285.193C190.069 285.193 223.772 296.98 245.132 296.735C266.491 296.488 238.012 187 238.012 187Z",
    fill: "#002159"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.100006,
    d: "M190.069 285.193C190.069 285.193 206.865 402.269 321.34 405.319C365.396 406.494 396.173 393.622 410.951 376.501C434.092 349.69 240.216 299.858 240.216 299.858L190.069 285.193Z",
    fill: "#002159"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M486.547 278.798C479.148 269.313 461.992 282.937 461.992 282.937C461.992 282.937 456.749 264.175 444.887 268.038C435.657 271.043 441.956 284.73 445.208 290.662C440.171 299.958 410.824 348.478 357.852 325.975C313.767 307.247 364.693 242.655 307.492 181.959H238.519C238.519 181.959 189.041 234.931 217.367 314.939C245.692 394.949 352.739 415.365 407.365 378.946C457.425 345.574 471.332 306.974 473.309 300.749C480.049 297.787 495.023 289.663 486.547 278.798Z",
    fill: "#829AB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.309 279.868C487.079 279.514 486.828 279.158 486.546 278.798C479.148 269.312 461.992 282.936 461.992 282.936C461.992 282.936 456.751 264.175 444.887 268.038C435.657 271.043 441.956 284.73 445.208 290.663C440.171 299.958 410.824 348.478 357.852 325.975C314.985 307.766 361.937 246.191 311.979 187C323.628 203.672 334.196 249.866 326.081 285.431C317.177 324.458 354.472 361.752 397.531 344.123C443.149 325.444 453.132 292.419 453.132 292.419C453.132 292.419 444.728 277.451 449.403 273.603C454.076 269.756 461.947 289.159 461.947 289.159C461.947 289.159 473.211 274.802 487.309 279.868Z",
    fill: "#BCCCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84 206.474C193.84 216.773 185.49 225.121 175.193 225.121C164.894 225.121 156.545 216.773 156.545 206.474C156.545 196.175 164.894 187.827 175.193 187.827C185.49 187.827 193.84 196.175 193.84 206.474Z",
    fill: "#BCCCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47 206.474C390.47 216.773 382.122 225.121 371.823 225.121C361.525 225.121 353.177 216.773 353.177 206.474C353.177 196.175 361.525 187.827 371.823 187.827C382.122 187.827 390.47 196.175 390.47 206.474Z",
    fill: "#BCCCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.541 10.7212C480.497 7.27184 470.917 5.60649 461.861 5.2865C490.541 10.7212 533.381 36.2038 544.341 94.0825C558.401 168.334 524.262 231.449 481.154 255.173C491.113 251.665 500.964 246.149 510.405 238.057C577.355 180.67 563.377 35.7358 490.541 10.7212Z",
    fill: "#A4CCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 554,
    height: 406,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyElephant);
export default __webpack_public_path__ + "static/media/grey-elephant.be448054092fa87a682fef849162da44.svg";
export { ForwardRef as ReactComponent };